module.exports = __webpack_public_path__ + "static/media/steven-binotto-V3Q5Ens9vh0-unsplash.646c1c4c.jpg";